module.exports = __webpack_public_path__ + "static/media/ma.f1e73245.svg";